module.exports = __webpack_public_path__ + "static/media/5.97be8b4f.jpg";